import { create } from "zustand";
import React from "react";

type LocationType = {
    description: string;
    headline: string;
    icon: React.ReactElement | null;
    id: number | string | null;
    type: string | null;
    latitude?: number | undefined | null;
    longitude?: number | undefined | null;
    subline?: string;
};

type InitialUserLocationStoreType = {
    initialUserLocation: LocationType | undefined;
    setInitialUserLocation: (newData: LocationType | undefined) => void;
};

export const useInitialUserLocationStore =
    create<InitialUserLocationStoreType>()((set) => ({
        initialUserLocation: undefined,
        setInitialUserLocation: (initialUserPosition) => {
            set({ initialUserLocation: initialUserPosition });
        },
    }));
